import {QueryKey, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {ApiAccessCredentialsResponse, ApiAccessInfo} from '../../../typings/user';
import {apiClient} from '../../utils/api-client';

function apiAccessQueryKey(userId: string): QueryKey {
    return ['api-access', userId];
}

function getApiAccessRequest(userId: string) {
    return apiClient.get<ApiAccessInfo>({
        path: `users-service/api/users/${userId}/api-access`
    });
}

function createApiAccessRequest(userId: string) {
    return apiClient.post<ApiAccessCredentialsResponse>({
        path: `users-service/api/users/${userId}/api-access`
    });
}

function deleteApiAccessRequest(userId: string) {
    return apiClient.delete<void>({
        path: `users-service/api/users/${userId}/api-access`
    });
}

export function useApiAccessQuery(userId: string) {
    return useQuery({
        queryKey: apiAccessQueryKey(userId),
        queryFn: () => getApiAccessRequest(userId)
    });
}

export function useCreateApiAccessMutation(userId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => createApiAccessRequest(userId),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: apiAccessQueryKey(userId)});
        }
    });
}

export function useDeleteApiAccessMutation(userId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => deleteApiAccessRequest(userId),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: apiAccessQueryKey(userId)});
        }
    });
}
